import { matchesAny } from './parseShortcut';
import type { ShortcutDefinition } from './types';

class GlobalShortcutRegistry {
  private shortcuts = new Map<string, ShortcutDefinition>();

  register(def: ShortcutDefinition): () => void {
    this.shortcuts.set(def.id, def);
    return () => this.shortcuts.delete(def.id);
  }

  unregister(id: string) {
    this.shortcuts.delete(id);
  }

  clear() {
    this.shortcuts.clear();
  }

  handle(event: KeyboardEvent, options: { modalOpen: boolean; scope: string }): boolean {
    const list = [...this.shortcuts.values()]
      .filter((s) => {
        if (options.modalOpen && !s.allowInModal) return false;
        if (s.enabled && !s.enabled()) return false;
        if (s.scope && s.scope !== options.scope && s.scope !== 'global') return false;
        return true;
      })
      .sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100));

    for (const def of list) {
      if (matchesAny(event, def.keys)) {
        if (def.preventDefault !== false) {
          event.preventDefault();
          event.stopPropagation();
        }
        def.handler(event);
        return true;
      }
    }
    return false;
  }

  list(): ShortcutDefinition[] {
    return [...this.shortcuts.values()];
  }
}

export const globalShortcutRegistry = new GlobalShortcutRegistry();
